import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [units, setUnits] = useParameter<number[]>("@units");

  useEffect(() => {
    setParameters(title, {
      "@units": units,
    });
  }, [title, units, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      // favourites saved before UOM control have no @units
      if (parameters["@units"]) {
        setUnits(parameters["@units"].map(Number));
      }
    },
    [setUnits]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);
}
